import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid'; // Make sure to install uuid
import { createCollectionData, getCollectionData, updateCollectionData } from '../../util/api';
import { addMarketplaceEntities, getListingsById } from '../../ducks/marketplaceData.duck';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/InviteFamiliesPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/InviteFamiliesPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/InviteFamiliesPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/InviteFamiliesPage/FETCH_TRANSACTION_ERROR';


export const USER_EXISTS_REQUEST = 'app/InviteFamiliesPage/USER_EXISTS_REQUEST';
export const USER_EXISTS_SUCCESS = 'app/InviteFamiliesPage/USER_EXISTS_SUCCESS';
export const USER_EXISTS_ERROR = 'app/InviteFamiliesPage/USER_EXISTS_ERROR';

export const GET_ALL_USERS_REQUEST = 'app/InviteFamiliesPage/GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'app/InviteFamiliesPage/GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_ERROR = 'app/InviteFamiliesPage/GET_ALL_USERS_ERROR';

export const GET_FAVORITE_LISTINGS_REQUEST = 'app/FavoritesPage/GET_FAVORITE_LISTINGS_REQUEST';
export const GET_FAVORITE_LISTINGS_SUCCESS = 'app/FavoritesPage/GET_FAVORITE_LISTINGS_SUCCESS';
export const GET_FAVORITE_LISTINGS_ERROR = 'app/FavoritesPage/GET_FAVORITE_LISTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  transitionError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  getAllExistUser: [],
  monthlyTimeSlots: {
    // Example format:
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  alreadyExistsInprogress: false,
  getAllUserExistsInprogress: false,
  alreadyExistsError: null,
  favoriteListingRefs: [],
  fetchFavoriteListingsInProgress: false,
  fetchFavoriteListingsError: null,
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: { uuid: 2 } }, { id: { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: { uuid: 2 } }, { id: { uuid: 1 } }]


export default function FavoritesPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };

    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data?.data?.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }

    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

    case USER_EXISTS_REQUEST:
      return { ...state, alreadyExistsInprogress: true, alreadyExistsError: null };

    case USER_EXISTS_SUCCESS: {
      return { ...state, alreadyExistsInprogress: false, payload };
    }

    case USER_EXISTS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, alreadyExistsInprogress: false, alreadyExistsError: payload };

    case GET_ALL_USERS_REQUEST:
      return { ...state, getAllUserExistsInprogress: true, alreadyExistsError: null };

    case GET_ALL_USERS_SUCCESS: {
      return { ...state, getAllUserExistsInprogress: false, getAllExistUser: payload };
    }

    case GET_ALL_USERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, getAllUserExistsInprogress: false, alreadyExistsError: payload };

    case GET_FAVORITE_LISTINGS_REQUEST:
      return {
        ...state,
        fetchFavoriteListingsInProgress: true,
        fetchFavoriteListingsError: null,
      };

    case GET_FAVORITE_LISTINGS_SUCCESS:
      return {
        ...state,
        fetchFavoriteListingsInProgress: false,
        favoriteListingRefs: payload,
      };

    case GET_FAVORITE_LISTINGS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchFavoriteListingsInProgress: false,
        fetchFavoriteListingsError: payload,
      };


    default:
      return state;
  }
}
// ================ Selectors ================ //

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });

const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});

const fetchTransactionError = e => ({
  type: FETCH_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

const alreadyExistsRequest = () => ({ type: USER_EXISTS_REQUEST });

const alreadyExistsSuccess = response => ({
  type: USER_EXISTS_SUCCESS,
  payload: response,
});

const alreadyExistsError = e => ({
  type: USER_EXISTS_ERROR,
  error: true,
  payload: e,
});

const getAllUserRequest = () => ({ type: GET_ALL_USERS_REQUEST });

const getAllUserSuccess = Data => ({
  type: GET_ALL_USERS_SUCCESS,
  payload: Data,
});

const getAllUserError = e => ({
  type: GET_ALL_USERS_ERROR,
  error: true,
  payload: e,
});

const getFavoriteListingsRequest = () => ({
  type: GET_FAVORITE_LISTINGS_REQUEST,
});

const getFavoriteListingsSuccess = data => ({
  type: GET_FAVORITE_LISTINGS_SUCCESS,
  payload: data,
});

const getFavoriteListingsError = e => ({
  type: GET_FAVORITE_LISTINGS_ERROR,
  error: true,
  payload: e,
});


// ================ Thunks ================ //


export const applyInvitation = ({ values }) => (dispatch) => {
  dispatch(fetchTransactionRequest());

  const { email } = values.values;
  const { verificationCode, inviterId, inviterName, baseURL } = values;
  const expiresAt = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

  const payload = {
    email: email,
    inviterId,
    verificationCode,
    inviterName,
    isUsed: false,
    expiresAt,
    createdAt: new Date(),
    status: "pending",
    url: baseURL
  };

  return createCollectionData({ payload })
    .then((response) => {
      dispatch(fetchTransactionSuccess(response));
      return response;
    })
    .catch((error) => {
      dispatch(fetchTransactionError(error));
    });
};

export const alreadyExists = (values) => (dispatch) => {
  dispatch(alreadyExistsRequest());
  const { email } = values.values;
  const query = { email };
  const options = { limit: 1 };

  return getCollectionData({
    tableName: "Invitation_Data",
    query,
    options,
    fnCallback: false,
  })
    .then((response) => {
      dispatch(alreadyExistsSuccess(response));
      return response.data[0] || [];
    })
    .catch((error) => {
      dispatch(alreadyExistsError(error));
    });
};


export const getAllUser = (currentUserId) => async (dispatch) => {
  dispatch(getAllUserRequest());

  const query = { inviterId: currentUserId };
  const options = {};

  try {
    const response = await getCollectionData({
      tableName: "Invitation_Data",
      query,
      options,
      fnCallback: false,
    });
    const invitations = response?.data || [];
    const today = new Date();

    const updatedInvitations = await Promise.all(
      invitations.map(async (invitation) => {
        const expiryDate = new Date(invitation.expiresAt);
        const isExpired = expiryDate < today && invitation.status === "pending";

        if (isExpired) {
          const payload = { status: "expired" };
          await updateCollectionData({
            id: invitation._id,
            tableName: "Invitation_Data",
            payload,
            fnCallback: false,
          });

          return { ...invitation, status: "expired" }; // Reflect updated status locally
        }

        return invitation;
      })
    );

    dispatch(getAllUserSuccess(updatedInvitations));
    return updatedInvitations;
  } catch (error) {
    dispatch(getAllUserError(error));
  }
};

export const fetchFavoriteListings = config => async (dispatch, getState, sdk) => {
  dispatch(getFavoriteListingsRequest());

  try {
    const { currentUser } = getState().user;
    const favoriteIds =
      currentUser?.attributes?.profile?.publicData?.favorites || [];

    if (!favoriteIds.length) {
      dispatch(getFavoriteListingsSuccess([]));
      return [];
    }

    const {
      layout: {
        listingImage: {
          aspectWidth = 1,
          aspectHeight = 1,
          variantPrefix = 'listing-card',
        } = {},
      } = {},
    } = config || {};

    const aspectRatio = aspectHeight / aspectWidth;
    const imageFields = [
      'variants.scaled-small',
      'variants.scaled-medium',
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      'variants.square-small',
      'variants.square-small2x',
    ];

    const fetches = favoriteIds.map(id =>
      sdk.listings.show({
        id,
        include: ['author', 'images', 'author.profileImage'],
        'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
        'fields.user': ['profile', 'profile.abbreviatedName', 'profile.publicData'],
        'fields.image': imageFields,
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      })
    );

    const responses = await Promise.all(fetches);
    responses.forEach(response => dispatch(addMarketplaceEntities(response)));

    const listingRefs = responses.map(res => res.data.data.id);
    dispatch(getFavoriteListingsSuccess(listingRefs));
    return getListingsById(getState(), listingRefs);
  } catch (error) {
    dispatch(getFavoriteListingsError(storableError(error)));
    return [];
  }
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const currentUserId = params?.id || "";
  return Promise.all([
    dispatch(getAllUser(currentUserId)),
    dispatch(fetchFavoriteListings(config)),
  ]);
};
